// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6abf2b14","484":"f30867f7","551":"1db763d1"}[chunkId] + ".chunk.js";
};